import { render, staticRenderFns } from "./SignatureGateModal.vue?vue&type=template&id=7374d96a&scoped=true"
import script from "./SignatureGateModal.vue?vue&type=script&lang=js"
export * from "./SignatureGateModal.vue?vue&type=script&lang=js"
import style0 from "./SignatureGateModal.vue?vue&type=style&index=0&id=7374d96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374d96a",
  null
  
)

export default component.exports